import { render, staticRenderFns } from "./ideal.vue?vue&type=template&id=2269fb14&scoped=true"
import script from "./ideal.vue?vue&type=script&lang=js"
export * from "./ideal.vue?vue&type=script&lang=js"
import style0 from "./ideal.vue?vue&type=style&index=0&id=2269fb14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269fb14",
  null
  
)

export default component.exports